export enum NodeType {
  PROCESS = "Process",
  SWIMLANE = "Swimlane",
  STEP = "Step",
  FIELD = "Field",
  ADD_FIELD = "AddField",
  ADD_STEP = "AddStep",
  ADD_SWIMLANE = "AddSwimlane",
  FLOW_SWIMLANE = "FlowSwimlane",
  FLOW_SWIMLANE_COLUMN = "FlowSwimlaneColumn",
  FLOW_SWIMLANE_ROW = "FlowSwimlaneRow",
  FLOW_SWIMLANE_UPWARDS_RULE_INDICATOR = "FlowSwimlaneUpwardsRuleIndicator",
  FLOW_SWIMLANE_DOWNWARDS_RULE_INDICATOR = "FlowSwimlaneDownwardsRuleIndicator",
  FLOW_STEP = "FlowStep",
  FLOW_STEP_COLUMN = "FlowStepColumn",
  PROCESS_FLOW = "ProcessFlow"
}

export enum ObjectNodeType {
  OBJECT = "Object",
  SECTION = "Section",
  ADD_SECTION = "AddSection",
  ADD_FIELD = "AddField",
  FIELD = "ObjectField",
  OBJECT_RELATIONSHIPS_NODE = "ObjectRelationshipsNode",
  OBJECT_RELATIONSHIP = "ObjectRelationship"
}
